/* RL Landing video — lazy load, autoplay in view, click to pause.
   Vanilla, no module. Prefixed globals only.

   The video is low in the page and must not compete with the hero for
   bandwidth or the LCP, so its file is not fetched at page load: the URL
   lives in data-src and is only moved to src when the frame nears the
   viewport. Playback starts then, loops muted, and pauses/resumes on a
   click. A play glyph (CSS) shows only while paused. */
(function () {
  'use strict';

  /* Start fetching a little before the frame is fully on screen so the
     first loop is ready by the time it is seen. */
  var RL_VIDEO_ROOT_MARGIN = '200px 0px';

  function RL_VIDEO_load(frame, video) {
    if (frame.hasAttribute('data-rl-video-loaded')) return;
    var src = video.getAttribute('data-src');
    if (!src) return;
    frame.setAttribute('data-rl-video-loaded', '');
    video.src = src;
    video.load();
    var played = video.play();
    if (played && typeof played.catch === 'function') played.catch(function () {});
  }

  function RL_VIDEO_start(frame) {
    var toggle = frame.querySelector('[data-rl-video-toggle]');
    var video = frame.querySelector('video');
    if (!toggle || !video) return;
    if (frame.hasAttribute('data-rl-video-wired')) return;
    frame.setAttribute('data-rl-video-wired', '');

    function sync() {
      frame.setAttribute('data-rl-video-state', video.paused ? 'paused' : 'playing');
    }

    toggle.addEventListener('click', function () {
      /* First click before the observer fired still loads it. */
      if (!frame.hasAttribute('data-rl-video-loaded')) {
        RL_VIDEO_load(frame, video);
        return;
      }
      if (video.paused) {
        var played = video.play();
        if (played && typeof played.catch === 'function') played.catch(function () {});
      } else {
        video.pause();
      }
    });

    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);

    /* Lazy trigger: load + autoplay only once the frame is near view. */
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              RL_VIDEO_load(frame, video);
              observer.disconnect();
              break;
            }
          }
        },
        { rootMargin: RL_VIDEO_ROOT_MARGIN }
      );
      observer.observe(frame);
    } else {
      /* No observer support: fall back to loading immediately. */
      RL_VIDEO_load(frame, video);
    }

    sync();
  }

  function RL_VIDEO_init() {
    var frames = document.querySelectorAll('[data-rl-video]');
    for (var i = 0; i < frames.length; i++) RL_VIDEO_start(frames[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', RL_VIDEO_init);
  } else {
    RL_VIDEO_init();
  }

  document.addEventListener('shopify:section:load', RL_VIDEO_init);
})();
